export default {
  "activityList": "活动列表",
  "search": "搜索",
  "refresh": "刷新",
  "add": "添加",
  "activityConfiguration": "活动配置",
  "noEventsYet": "暂无活动",
  "eventName": "活动名称",
  "eventFormat": "举办方式",
  "inPerson": "线下",
  "online": "线上",
  "registrationDeadline": "报名截止时间",
  "eventStartsAt": "活动开始时间",
  "eventEndsAt": "活动结束时间",
  "status": "状态",
  "createdAt": "创建时间",
  "sortWeight": "权重",
  "visibility": "显示状态",
  "visible": "显示",
  "hidden": "隐藏",
  "miniProgramCode": "活动小程序码",
  "comingSoon": "后续接入",
  "actions": "操作",
  "settings": "设置",
  "addActivity": "添加活动",
  "backToList": "返回列表",
  "eventCarousel": "活动轮播图",
  "carouselImage": "轮播图",
  "notUploaded": "待上传",
  "delete": "删除",
  "addImage": "新增",
  "orPasteAnImageURL": "或粘贴图片地址",
  "addURL": "添加地址",
  "recommendedSize686320PxClickAdd": "图片建议尺寸(686*320)；点「新增」上传，点 × 可删除",
  "contact": "联系人",
  "contactNumber": "联系电话",
  "onlineURL": "线上网址",
  "venueAddress": "线下地址",
  "enterTheVenueAddress": "请输入线下地址",
  "selectDateAndTime": "选择日期时间",
  "eventTime": "活动时间",
  "to045": "至",
  "start": "开始时间",
  "end": "结束时间",
  "eventDetails": "活动详情",
  "access": "对外状态",
  "public": "对外开放",
  "membersOnly": "会员专属",
  "publicAnyoneCanViewTheEventDetails": "对外开放：所有信息对外公开，可进入活动详情；",
  "membersOnlyOnlyApprovedMembersCanView": "会员专属：只有入会成功后的会员才可进入活动详情（仅会员可查看）。",
  "participantLimit": "报名限制人数",
  "leaveBlankForNoLimit": "不填表示不限制",
  "leaveBlankToAllowUnlimitedParticipants": "备注：不填没有人数限制",
  "save": "保存",
  "showExpiredActivities": "过期活动是否展示：",
  "show": "展示",
  "hide": "不展示",
  "oK": "确定",
  "all": "全部",
  "registrationOpen": "报名中",
  "inProgress": "进行中",
  "ended": "已结束",
  "eventNameIsRequired": "请输入活动名称",
  "enterAContactName": "请输入联系人",
  "enterAContactNumber": "请输入联系电话",
  "selectAnEventFormat": "请选择举办方式",
  "enterTheVenueAddress070": "请填写线下地址",
  "selectARegistrationDeadline": "请选择报名截止时间",
  "selectTheEventStartAndEndTimes": "请选择活动开始和结束时间",
  "enterEventDetails": "请填写活动详情",
  "enterAnImageURLFirst": "请先填写图片地址",
  "uploadFailed": "上传失败",
  "imageUploaded": "图片已上传",
  "couldNotLoadData": "加载失败",
  "couldNotLoadConfiguration": "配置加载失败",
  "activityConfigurationSaved": "活动配置已保存",
  "couldNotSaveChanges": "保存失败",
  "activityCreated": "活动已创建",
  "deleteActivity": "确认删除活动「{p0}」？",
  "deleteActivity083": "删除活动",
  "deleted": "已删除",
  "couldNotDelete": "删除失败",
  "activityRefunds": "活动退款",
  "noRefundRequests": "暂无退款申请",
  "orderNumber": "订单号",
  "userNickname": "用户昵称",
  "userAvatar": "用户头像",
  "userPhone": "用户电话",
  "registrationFee": "报名费用",
  "refundAmount": "退款费用",
  "reviewStatus": "审核状态",
  "processedAt": "处理时间",
  "approve": "通过",
  "reject": "驳回",
  "pending": "待审核",
  "approved": "已通过",
  "rejected": "已驳回",
  "approveTheRefundRequestFor": "确认通过「{p0}」的退款申请？",
  "approveRefund": "通过审核",
  "enterARejectionReasonOptional": "请填写驳回原因（可空）",
  "rejectRequest": "驳回申请",
  "cancel": "取消",
  "rejectionReason": "驳回原因",
  "couldNotReviewRefund": "审核失败",
  "back": "返回",
  "activityInformation": "活动信息",
  "photoLive": "照片直播",
  "eventRegistration": "活动报名",
  "registrations": "报名列表",
  "eventDetailsPlaceholder": "请输入活动详情",
  "setUpAFormUnderEventRegistration": "请先在「活动报名」中设置报名表",
  "couldNotLoadActivity": "活动加载失败",
  "activityInformationSaved": "活动信息已保存",
  "linkAPhotoLiveAlbumFromThe": "关联会务系统「照片直播」中的相册，关联后可在对应活动页面展示直播相册入口。选填，不强制关联。每个协会活动最多关联一个相册。",
  "linkPhotoLiveAlbum": "关联照片直播",
  "photoLiveAlbum": "选择照片直播相册",
  "noAlbum": "— 不关联 —",
  "saveLink": "保存关联",
  "unlink": "取消关联",
  "currentlyLinked": "当前已关联：{p0}",
  "noPhotoLiveAlbumLinkedOptionallySelect": "尚未关联任何照片直播相册，可在上方下拉框中选择关联（选填）。",
  "photoLiveAlbumLinked": "照片直播关联已保存",
  "photoLiveAlbumUnlinked": "已取消照片直播关联",
  "unlinkThePhotoLiveAlbumFromThis": "确认取消当前活动的照片直播关联？",
  "couldNotUnlinkAlbum": "取消失败",
  "basicSettings": "基础设置",
  "registrationForm": "报名表",
  "selectTheQuestionnaireForThisEventOnly": "选择本活动使用的问卷表格（仅展示已发布问卷）",
  "selectARegistrationForm": "请选择报名表",
  "saveSettings": "保存设置",
  "ifNoFormsAreAvailableCreateAnd": "若无可选报名表，请先在「问卷管理」中新增并发布一个报名表。",
  "manageQuestionnaires": "前往配置",
  "advancedSettings": "高级设置",
  "allowRepeatedSubmissions": "允许重复提交",
  "whenOffOneSubmissionPerPersonPer": "关闭时：同一人在同一份问卷下只能提交一次",
  "allowNonMembersToRegister": "允许未入会会员提交",
  "whenOnUsersCanRegisterAfterSigning": "开启后只需登录即可报名；关闭后该用户必须先入会",
  "registrationSettingsSaved": "报名设置已保存",
  "noMatchingRecords": "没有找到匹配的记录",
  "registeredAt": "报名时间",
  "paidAt": "付款时间",
  "checkInStatus": "核销状态",
  "view": "查看",
  "activity": "选择活动:",
  "user": "用户信息:",
  "selectAUser": "请选择用户",
  "selectUser": "选择用户",
  "nicknameOrPhoneNumber": "昵称或手机号",
  "reset": "重置",
  "noUsersAvailable": "暂无可选用户",
  "avatar": "头像",
  "nickname": "昵称",
  "phoneNumber": "手机号",
  "select": "选择",
  "registrationDetails": "报名详情",
  "couldNotLoadUsers": "加载用户失败",
  "registrationAdded": "报名已添加",
  "couldNotAddRegistration": "添加失败",
  "deleteTheRegistrationFor": "确认删除「{p0}」的报名记录？",
  "deleteRegistration": "删除报名",
  "recordRange": "显示第 {from} 到第 {to} 条记录，总共 {total} 条记录",
  "totalRecords": "共 {total} 条记录",
  "activityTitle": "活动设置 · {name}",
  "imageUploadFailed": "图片上传失败",
  "paid": "已付款",
  "refunding": "退款中",
  "refunded": "已退款",
  "unpaid": "未支付",
  "checkedIn": "已核销",
  "checkInNotRequired": "无需核销",
  "notCheckedIn": "未核销",
  "activitySettings": "活动设置"
}
